import { gql } from "graphql-tag";

const getAsignaciones = gql`
  query Questions ($args: FilterParamsInput) {
    allocations(args: $args) {
      due_date
      id
      institution_id
      start_date
      status
      questionary {
        id
        name
      }
      responsible_email
      responsible_full_name
      responsible_role
      sent_surveys_count
    }
    findAll_institutions {
      id
      company_name
      company_country
      alias
      is_active
    }
  }
`;

const getInstituciones = gql`
query FindAll_institutions {
  findAll_institutions {
    id
    company_name
    company_country
    alias
    is_active
  }
}
`;




export { getAsignaciones, getInstituciones }